import { Text } from '@wix/design-system';
import {
  AI_ANALYZING_TRANSLATION_KEY,
  SparkleIcon,
  useAiAnalyzing,
  useAiRecommendationEnabled,
} from '@wix/package-picker-shared-eclipse';
import classNames from 'classnames';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import s from './AiAnalyzingIndicator.scss';

export const AiAnalyzingIndicator: React.FC = () => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();
  const { isEnabled } = useAiRecommendationEnabled();
  const isAnalyzing = useAiAnalyzing();

  if (!isEnabled) {
    return null;
  }

  return (
    <div
      className={classNames(s.indicator, { [s.hidden]: !isAnalyzing })}
      data-hook="ai-analyzing-indicator"
      role="status"
      aria-live="polite"
      aria-hidden={!isAnalyzing}
    >
      <SparkleIcon svgClassName={s.sparkle} />
      <Text size="small" weight="bold" className={s.shimmerText}>
        {t(AI_ANALYZING_TRANSLATION_KEY)}
      </Text>
    </div>
  );
};
